import React, { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { withTheme } from 'react-jsonschema-form';
import LayoutField from 'react-jsonschema-form-layout-2';
import Bootstrap4Theme from 'react-jsonschema-form-bs4';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { deleteLocation, getLocation } from 'api/api';

const breadcrumbItems = [
  {
    label: 'Locations',
    url: '/locations/locations'
  },
  {
    label: 'Delete',
    active: true
  }
];

function DeleteLocation() {
  const navigate = useNavigate();
  const Form = withTheme(Bootstrap4Theme);
  const [formData, setFormData] = useState();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    loadData(id);
  }, [id]);

  const loadData = id => {
    setError([]);
    setLoading(true);

    getLocation(id)
      .then(response => {
        setFormData({
          id: response.data.data.id,
          name: response.data.data.name,
          address:
            response.data.data.address === null
              ? ''
              : response.data.data.address,
          description:
            response.data.data.description === null
              ? ''
              : response.data.data.description,

          is_untracked:
            response.data.data.is_untracked === null ||
            response.data.data.is_untracked === false
              ? false
              : response.data.data.is_untracked === true
              ? true
              : false
        });
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = ({ formData }) => {
    setError([]);
    setFormData(formData);
    setLoading(true);

    deleteLocation(id)
      .then(response => {
        if (response.status === 204) navigate('/locations/locations');
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const schema = {
    type: 'object',
    properties: {
      name: {
        title: 'Location Name',
        type: 'string',
        readOnly: true
      },

      address: {
        title: 'Address',
        type: 'string',
        readOnly: true
      },

      description: {
        title: 'Description',
        type: 'string',
        readOnly: true
      },
      is_untracked: { type: 'boolean', title: ' Do Not Track' }
    }
  };

  const uiSchema = {
    'ui:field': 'layout',
    description: {
      'ui:widget': 'textarea',
      'ui:disabled': true,
      classNames: 'mb-2'
    },
    'ui:layout': [
      { name: { md: 8 } },
      { address: { md: 8 } },
      { description: { md: 8 } },
      { is_untracked: { md: 8 } }
    ],
    name: {
      'ui:disabled': true
    },
    address: {
      'ui:disabled': true
    },
    is_untracked: {
      'ui:disabled': true
    }
  };

  const fields = {
    layout: LayoutField
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">Delete Location</h2>
            <h5 className="text-700 fw-semi-bold">Delete a location</h5>
          </div>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <Form
                schema={schema}
                uiSchema={uiSchema}
                fields={fields}
                onSubmit={handleSubmit}
                formData={formData}
                showErrorList={false}
              >
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ marginTop: '10px' }}
                >
                  <Button variant="danger" type="submit">
                    Delete
                  </Button>
                  <Button
                    variant="phoenix-secondary"
                    type="button"
                    onClick={() => navigate('/locations/locations')}
                  >
                    Discard
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default DeleteLocation;
